module.exports = __webpack_public_path__ + "img/freespin_feature.090a4cc1.png";